import { markDone } from './state'

const contactClickHandlers = new WeakMap()

function getContactClickTarget(element) {
  if (!element) return null
  return element.querySelector('button, a') || element
}

function goToContactForm(event) {
  if (event && event.preventDefault) {
    event.preventDefault()
  }

  markDone('contacts-dashboard')
  sessionStorage.setItem('onboarding_next', 'contact-form')
  window.location.href = '/contacts/form/new'
}

// eslint-disable-next-line import/prefer-default-export
export const contactSteps = [
  {
    element: '[data-tour="new-contact-btn"]',
    disableActiveInteraction: false,
    onHighlighted: element => {
      const clickTarget = getContactClickTarget(element)
      if (!clickTarget) return

      contactClickHandlers.set(clickTarget, goToContactForm)
      clickTarget.addEventListener('click', goToContactForm)
    },
    onDeselected: element => {
      const clickTarget = getContactClickTarget(element)
      if (!clickTarget || !contactClickHandlers.has(clickTarget)) return

      clickTarget.removeEventListener('click', contactClickHandlers.get(clickTarget))
      contactClickHandlers.delete(clickTarget)
    },
    popover: {
      title: 'Create',
      description: 'Click here to create a new contact',
      position: 'bottom',
      showButtons: [],
    },
  },
]
